import React from 'react'
import './Termsandconditions.css'

const PrivacyPolicy = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">Privacy Policy</h1>
                <p className="legal-updated">Last updated: June 2026</p>

                <p className="legal-intro">
                    At Jenitas, we are committed to protecting your personal information and your right
                    to privacy. This Privacy Policy explains what information we collect, how we use
                    it, and your rights regarding your data.
                </p>

                <section className="legal-section">
                    <h2>1. Information We Collect</h2>
                    <p>When you use our website, we may collect the following information:</p>
                    <ul>
                        <li><strong>Account information</strong> — your name, email address, and password when you register</li>
                        <li><strong>Order information</strong> — your full name, delivery address, postal code, and contact number when you place an order</li>
                        <li><strong>Usage data</strong> — pages visited, products viewed, and cart activity to improve your shopping experience</li>
                    </ul>
                    <p>We do not collect payment card details. Payments are made via bank transfer and we only receive confirmation through your payment slip.</p>
                </section>

                <section className="legal-section">
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Process and fulfil your orders</li>
                        <li>Communicate with you about your orders via WhatsApp or email</li>
                        <li>Maintain and improve our website and services</li>
                        <li>Send you updates about your order status</li>
                        <li>Respond to your enquiries and support requests</li>
                    </ul>
                    <p>
                        We do not sell, trade, or rent your personal information to third parties.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>3. How We Store Your Information</h2>
                    <p>
                        Your personal data is stored securely in our database. Passwords are encrypted
                        and never stored in plain text. We take reasonable technical and organisational
                        measures to protect your information from unauthorised access, loss, or misuse.
                    </p>
                    <p>
                        We retain your personal information for as long as your account is active or
                        as needed to fulfil our legal obligations.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>4. Cookies</h2>
                    <p>
                        Our website uses browser local storage to keep you logged in and maintain your
                        shopping cart between sessions. We do not use third-party tracking cookies or
                        advertising cookies.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>5. Third-Party Services</h2>
                    <p>We use the following third-party services to operate our website:</p>
                    <ul>
                        <li><strong>Cloudinary</strong> — for storing and delivering product images</li>
                        <li><strong>Railway</strong> — for hosting our website and database</li>
                        <li><strong>WhatsApp</strong> — for order communication and payment confirmation</li>
                    </ul>
                    <p>
                        These services have their own privacy policies and we encourage you to review
                        them. We share only the minimum necessary information with these services.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>6. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access the personal information we hold about you</li>
                        <li>Request correction of inaccurate information</li>
                        <li>Request deletion of your account and personal data</li>
                        <li>Withdraw consent for us to use your data at any time</li>
                    </ul>
                    <p>
                        To exercise any of these rights, please contact us at{' '}
                        <a href="mailto:jenitas@gmail.com">jenitas@gmail.com</a>.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>7. Children's Privacy</h2>
                    <p>
                        Our website is not directed at children under the age of 13. We do not
                        knowingly collect personal information from children. If you believe we have
                        inadvertently collected such information, please contact us immediately.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>8. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. Any changes will be posted
                        on this page with an updated date. We encourage you to review this policy
                        periodically to stay informed about how we protect your information.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>9. Contact Us</h2>
                    <p>
                        If you have any questions or concerns about this Privacy Policy, please contact us:
                    </p>
                    <ul>
                        <li>Email: <a href="mailto:jenitas@gmail.com">jenitas@gmail.com</a></li>
                        <li>Location: Bandarawela, Sri Lanka</li>
                    </ul>
                </section>
            </div>
        </div>
    )
}

export default PrivacyPolicy